var App = App || {};

App.LogoCarousel = (function ($) {
    'use strict';

    function init() {
        $('.brand-slider').slick({
            infinite: true,
            variableWidth: true,
            slidesToShow: 6,
            slidesToScroll: 1,            
            arrows: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.LogoCarousel.init();
});